import { useQuery } from '@tanstack/react-query';
import { invoiceService } from '../services/invoiceService';
import type { Invoice } from '../types/invoice.types';

const EMPTY: Invoice[] = [];

/** Phase 6: see useServices for why. Exported shape unchanged. */
export function useInvoices() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['billing', 'invoices'],
    queryFn: () => invoiceService.list(),
  });

  return {
    data: data ?? EMPTY,
    isLoading,
    error: (error as Error | null) ?? null,
    refetch,
  };
}
